<template>
  <div id="pdf-template-preview">
    <canvas id="template-canvas"></canvas>
  </div>
</template>

<script>
import PdfTemplatePreview from "@/models/PdfTemplatePreview.js";
export default {
  name: "pdf-template-preview",
  props: {
    template: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {};
  },
  watch: {
    template: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
  },
  methods: {
    initialize() {
      const preview = new PdfTemplatePreview(
        this.template,
        document.getElementById("template-canvas")
      );
      const parent = document.getElementById("pdf-template-preview")
        .parentElement;
      preview.draw(parent.clientWidth - 50, parent.clientHeight - 50);
    },
  },
};
</script>

<style>
</style>